export const isDismantledMeterStatus = (meterStatus) => {
  return (meterStatus?.name || '').toLowerCase() === 'демонтирован';
};
